import { ValueOf } from '@/types/util';

/** QRコードダウンロードパターンのenum */
export const EQrDownloadPattern = {
  UNSPECIFIED_AMOUNT: '金額指定なし',
  SPECIFIED_AMOUNT: '金額指定あり',
} as const;

export type QrDownloadPatternKey = keyof typeof EQrDownloadPattern;
export type QrDownloadPatternValue = ValueOf<typeof EQrDownloadPattern>;

export const qrDownloadPatternKeys = Object.keys(EQrDownloadPattern) as (QrDownloadPatternKey[]);

/** v-select用items */
export const qrDownloadPatternItems = qrDownloadPatternKeys
  .map((key) => ({
    title: EQrDownloadPattern[key],
    value: key,
  }));
